import { registerControllers } from 'stimulus-vite-helpers'
import { Toggle, Modal } from 'tailwindcss-stimulus-components'
import TextareaAutogrow from 'stimulus-textarea-autogrow'
import PasswordVisibility from '@stimulus-components/password-visibility'

import { stimulus } from '~/init'

stimulus.register('modal-sync', Modal)
stimulus.register('toggle', Toggle)
stimulus.register('textarea-autogrow', TextareaAutogrow)
stimulus.register('password-visibility', PasswordVisibility)

const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(stimulus, controllers)
